import React, { useState } from "react";
import "./experience.css";
import { BsBriefcaseFill, BsCalendarCheck } from "react-icons/bs";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const Experience = () => {
  const experiences = [
    {
      title: "Desarrollador Backend",
      company: "Mepryl | Centro Médico",
      date: "2025 - 2026",
      details: [
        "Desarrollo y mantenimiento de un sistema ERP con facturación electrónica, control de inventario y gestión de ventas.",
        "Desarrollo de funcionalidades backend utilizando Laravel, PHP, CodeIgniter y Node.js para servicios RESTful y sincronización.",
        "Implementación de tiendas virtuales integradas con pasarelas de pago locales e internacionales.",
      ],
    },
    {
      title: "Desarrollador Backend",
      company: "Cruz del Sur - ARGENTINA",
      date: "2023 - 2024",
      details: [
        "Desarrollé y mantuve módulos backend en C#.NET, VB.NET y ASP.NET (Web Forms), SQL Server.",
        "Administré entornos de producción asegurando disponibilidad continua y optimización de bases de datos.",
        "Implementación de servicios web internos en ASP.NET, utilizando C# y Visual Basic .NET.",
      ],
    },
    {
      title: "Desarrollador Backend",
      company: "TKcontackto - PERÚ",
      date: "2019 - 2022",
      details: [
        "Desarrollo de backend para un sistema ERP integral de gestión para call center.",
        "Implementación de aplicaciones backend utilizando Node.js y Express, enfocadas en alto rendimiento.",
        "Desarrollo de interfaces de usuario con WinForms y WPF para herramientas internas del equipo.",
      ],
    },
  ];

  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    setCurrent(current === experiences.length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? experiences.length - 1 : current - 1);
  };

  return (
    <section id="experience">
      <h5>Trayectoria</h5>
      <h2>Mi Experiencia</h2>

      <div className="container experience__container">
        <div className="experience__carousel">
          <button
            className="carousel__btn left desktop-btn"
            onClick={prevSlide}
          >
            <IoIosArrowBack />
          </button>

          <div className="carousel__content-wrapper">
            <div className="carousel__card">
              <div className="card__header">
                <div className="card__icon">
                  <BsBriefcaseFill />
                </div>
                <div>
                  <h3>{experiences[current].title}</h3>
                  <h4>{experiences[current].company}</h4>
                </div>
              </div>

              <div className="card__date">
                <BsCalendarCheck className="date__icon" />{" "}
                {experiences[current].date}
              </div>

              <ul className="card__list">
                {experiences[current].details.map((detail, idx) => (
                  <li key={idx}>{detail}</li>
                ))}
              </ul>
            </div>

            <div className="carousel__dots desktop-dots">
              {experiences.map((_, index) => (
                <span
                  key={index}
                  className={`dot ${current === index ? "active" : ""}`}
                  onClick={() => setCurrent(index)}
                ></span>
              ))}
            </div>
          </div>

          <div className="carousel__mobile-nav">
            <button className="carousel__btn left" onClick={prevSlide}>
              <IoIosArrowBack />
            </button>
            <div className="carousel__dots">
              {experiences.map((_, index) => (
                <span
                  key={index}
                  className={`dot ${current === index ? "active" : ""}`}
                  onClick={() => setCurrent(index)}
                ></span>
              ))}
            </div>
            <button className="carousel__btn right" onClick={nextSlide}>
              <IoIosArrowForward />
            </button>
          </div>

          <button
            className="carousel__btn right desktop-btn"
            onClick={nextSlide}
          >
            <IoIosArrowForward />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Experience;
